import moment from 'moment'
import Helper from './Helper'

const locale = 'en-US'
const compactFormatter = new Intl.NumberFormat(locale, { notation: 'compact' })
const formatter = new Intl.NumberFormat(locale)

const Formatter = {
    compact: (num: number) => (!Helper.hasVal(num) || isNaN(num)) ? ' ' : compactFormatter.format(num),
    number: (num: number) => (!Helper.hasVal(num) || isNaN(num)) ? ' ' : formatter.format(num),
    timeAgo: (date: Date) => {
        return moment(date).fromNow(false)
    },
    date: (d: Date, format?: 'mm/dd/yyyy' | 'mm/dd/yyyy hh:mm:ss' | 'mmm dd, yyyy' | 'full' | 'long' | 'iso'): string => {
        if (!d)
            return 'Invalid Date'

        let date = d

        if (typeof (d) === 'string')
            date = new Date(d)

        const options: { [key: string]: object } = {
            full: {
                month: 'short',
                day: 'numeric',
                year: 'numeric',
                hour: 'numeric',
                minute: '2-digit',
                second: '2-digit',
                hour12: true
            },
            long: {
                weekday: 'long',
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            },
            iso: {}
        }

        switch (format) {
            case 'mm/dd/yyyy':
                return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`
            case 'mm/dd/yyyy hh:mm:ss':
                return `${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()} ${date.getHours() < 10 ? '0' + date.getHours() : date.getHours()}:${date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()}:${date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()}`
            case 'mmm dd, yyyy':
                return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })
            case 'full':
                return date.toLocaleString('en-US', options.full)
            case 'long':
                return date.toLocaleDateString('en-US', options.long)
            case 'iso':
                return date.toISOString()
            default:
                return date.toLocaleDateString()
        }
    },

    // date: (d: Date, format: 'mm/dd/yyyy' | 'mmm dd, yyyy') => {
    //     if (!d) return ' '
    //     if (typeof d.getMonth === 'function') return d.toLocaleDateString()
    //     else {
    //         try {
    //             const d1 = new Date(d)
    //             return d1.toLocaleDateString()
    //         } catch {
    //             return d as any as string
    //         }
    //     }
    // },
    // dateFull: (d: Date) => {
    //     return d.toLocaleString('en-US', {
    //         month: 'short',
    //         day: 'numeric',
    //         year: 'numeric',
    //         hour: 'numeric',
    //         minute: '2-digit',
    //         second: '2-digit',
    //         hour12: true
    //     })
    // },
    /**
     * Format a date in this format: e.g. Monday, 26 August
     */
    // formatDate: (dd: Date) => {
    //     const dayName = dd.toLocaleDateString(locale, { weekday: 'long' })
    //     const day = dd.getDate()
    //     const monthName = dd.toLocaleDateString(locale, { month: 'long' })

    //     return `${dayName}, ${day} ${monthName}`
    // },
    // /**
    //  * Format a date in ISO 8601 format
    //  */
    // dateToISOString: (date: Date) => {
    //     return date instanceof Date && !isNaN(date.getTime())
    //         ? date.toISOString()
    //         : 'Invalid Date'
    // },
    bytes: (bytes: number, decimals = 2) => {
        if (!+bytes) return '0 Bytes'

        const k = 1024
        const dm = decimals < 0 ? 0 : decimals
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']

        const i = Math.floor(Math.log(bytes) / Math.log(k))

        return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`
    },
    timer(seconds: number, format?: 'long' | 'minutes') {
        const hours = Math.floor(seconds / 3600)
        const minutes = Math.floor((seconds % 3600) / 60)
        const remainingSeconds = seconds % 60

        switch (format) {
            case 'long': {
                const timeString = []

                if (hours > 0) {
                    timeString.push(`${hours} hour${hours > 1 ? 's' : ''}`)
                }

                if (minutes > 0) {
                    timeString.push(`${minutes} minute${minutes > 1 ? 's' : ''}`)
                }

                if (remainingSeconds > 0 || timeString.length === 0) {
                    timeString.push(`${remainingSeconds} second${remainingSeconds > 1 ? 's' : ''}`)
                }

                return timeString.join(' and ')
            }
            case 'minutes': {
                return `${String(minutes).padStart(2, '0')}:${String(remainingSeconds).padStart(2, '0')}`
            }
        }
    },

    transformDateForDataPicker: (dateString: string | null | undefined, period: 'from' | 'to'): string => {
        if (!dateString) {
            const today = new Date()
            const yyyy = today.getFullYear()
            const mm = String(today.getMonth() + 1).padStart(2, '0')
            const dd = String(today.getDate()).padStart(2, '0')

            return period === 'from'
                ? `${yyyy}-01-01`
                : `${yyyy}-${mm}-${dd}`
        }

        const [year, month, day] = dateString.split('/')
        return `${year}-${month}-${day}`
    },

    truncateIsoDate: (isoDate: string) => {
        const date = isoDate.substring(0, 10) ?? ''
        const time = isoDate.substring(11, 16) ?? ''
        const t = `${date} ${time}`
        return t
    }

}

export default Formatter
